import React, { useEffect, useRef } from 'react';

const BackgroundAnimation = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // אובייקט למעקב אחר מיקום העכבר
    const mouse = {
      x: null,
      y: null
    };

    // האזנה לתנועת העכבר
    const handleMouseMove = (event) => {
      mouse.x = event.x;
      mouse.y = event.y;
    };

    const handleMouseOut = () => {
      mouse.x = null;
      mouse.y = null;
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseout', handleMouseOut);

    function setCanvasSize() {
      const container = canvas.parentElement;
      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;
    }

    setCanvasSize();

    const colors = [
      '219, 234, 254', // --primary-100
      '191, 219, 254', // --primary-200
      '147, 197, 253', // --primary-300
      '96, 165, 250'   // --primary-400
    ];

    let particles = [];
    const numberOfParticles = 7;

    function random(min, max) {
      return Math.random() * (max - min) + min;
    }

    class Particle {
      constructor() {
        this.radius = random(120, 240);
        this.x = random(this.radius, canvas.width - this.radius);
        this.y = random(this.radius, canvas.height - this.radius);
        // מהירות בסיסית מוגברת
        this.baseDx = random(-0.8, 0.8);
        this.baseDy = random(-0.8, 0.8);
        this.dx = this.baseDx;
        this.dy = this.baseDy;
        this.color = colors[Math.floor(Math.random() * colors.length)];
      }

      draw() {
        ctx.beginPath();
        const gradient = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.radius);
        gradient.addColorStop(0, `rgba(${this.color}, 0.7)`);
        gradient.addColorStop(1, `rgba(${this.color}, 0)`);
        ctx.fillStyle = gradient;
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fill();
      }

      update() {
        // --- אינטראקציה עם העכבר ---
        if (mouse.x !== null && mouse.y !== null) {
          const dxMouse = this.x - mouse.x;
          const dyMouse = this.y - mouse.y;
          const distance = Math.sqrt(dxMouse * dxMouse + dyMouse * dyMouse);

          if (distance < 300) { // הגדלת טווח התגובה
            const forceDirectionX = dxMouse / distance;
            const forceDirectionY = dyMouse / distance;
            const maxDistance = 300;
            const force = (maxDistance - distance) / maxDistance;

            // הוספת כוח דחייה חזק יותר באופן משמעותי
            this.dx += forceDirectionX * force * 3;
            this.dy += forceDirectionY * force * 3;
          }
        }

        // --- תנועה טבעית והאטה (Easing) ---
        // החלקיק תמיד ינסה לחזור למהירות הבסיסית שלו
        this.dx += (this.baseDx - this.dx) * 0.01;
        this.dy += (this.baseDy - this.dy) * 0.01;

        this.x += this.dx;
        this.y += this.dy;

        // היפוך כיוון בגבולות הקנבס
        if (this.x + this.radius > canvas.width || this.x - this.radius < 0) {
          this.baseDx = -this.baseDx;
          this.dx = -this.dx;
        }
        if (this.y + this.radius > canvas.height || this.y - this.radius < 0) {
          this.baseDy = -this.baseDy;
          this.dy = -this.dy;
        }
      }
    }

    function init() {
      particles = [];
      for (let i = 0; i < numberOfParticles; i++) {
        particles.push(new Particle());
      }
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.update();
        p.draw();
      });
      requestAnimationFrame(animate);
    }

    const handleResize = () => {
      setCanvasSize();
      init();
    };

    window.addEventListener('resize', handleResize);

    init();
    animate();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseout', handleMouseOut);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -10,
        overflow: 'hidden',
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          top: '-5%',
          left: '-5%',
          width: '110%',
          height: '110%',
          filter: 'blur(25px)',
        }}
      />
    </div>
  );
};

export default BackgroundAnimation; 